<script setup lang="ts">
import { RouterView } from 'vue-router'
import LogService from './services/log'
import { nextTick, onBeforeUnmount, onMounted } from 'vue'

let intervalID = 0

const loadMaterialSymbols = () => {
  if (!document.fonts || !document.fonts.load) return // çok eski tarayıcılar

  // Fontu load etmeyi dene
  document.fonts.load('24px "Material Symbols Outlined"').then(() => {
    document.documentElement.classList.add('ms-font-hazir')
  })
}

onMounted(async () => {
  await nextTick()

  LogService.setupUnloadHandler()
  LogService.sync()
  intervalID = setInterval(() => {
    LogService.sync()
  }, 10 * 1000)
  loadMaterialSymbols()
})

onBeforeUnmount(() => {
  clearInterval(intervalID)
})
</script>

<template>
  <RouterView />
</template>
